export default {
  bmProButtonText: {
    id: 'header_bm_pro_button_text',
    defaultMessage: 'For business',
  },
  bmProButtonTextFrVariant: {
    id: 'header_bm_pro_button_text_fr_variant',
    defaultMessage: 'Business solutions',
  },
  bmProButtonTextUsVariant: {
    id: 'header_bm_pro_button_text_us_variant',
    defaultMessage: 'Business solutions',
  },
}
